import React from 'react';
import { Zap } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-96">
      <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between gap-4" data-id="element-97">
        <div className="flex items-center gap-2 min-w-0" data-id="element-98">
          <Zap className="w-5 h-5 text-blue-500 shrink-0" data-id="element-99" />
          <span className="font-bold text-base tracking-tight text-slate-100 hidden sm:block truncate" data-id="element-100">
            EL INTERRUPTOR DE NITRÓGENO
          </span>
          <span className="font-bold text-base tracking-tight text-slate-100 sm:hidden truncate" data-id="element-101">
            NITRÓGENO
          </span>
        </div>
        <a href="#comprar" className="flex justify-center items-center shrink-0 bg-blue-600 hover:bg-blue-500 text-white font-semibold py-1.5 px-3 rounded-full transition-all duration-300 shadow-[0_0_12px_rgba(37,99,235,0.35)] hover:shadow-[0_0_20px_rgba(37,99,235,0.55)] hover:scale-105 active:scale-95 text-xs" data-id="element-102">
          Quiero los Bonos
        </a>
      </div>
    </header>;
}